import axios from 'axios';
import utilities from '@/assets/scripts/utilities';
import { ENGAGE_URLS, SIGNATURE_STATUS, RESPONSE_STATUS } from '@/static/global-variables';

let instanceV1;
let instanceV2;
let token;

function getEngageServerHost(hostname) {
    const engageServerDomain = ENGAGE_URLS.BASE;
    if (hostname && hostname.includes('engage-sbx.veeva.com')) {
        return engageServerDomain.replace('engage-', 'engage-sbx-');
    } else {
        return engageServerDomain;
    }
}

function getInstanceV1() {
    if (!instanceV1) {
        instanceV1 = axios.create({
            baseURL: getEngageServerHost(window.location.hostname) + ENGAGE_URLS.API_V1
        });
    }
    return instanceV1;
}

function getInstanceV2() {
    if (!instanceV2) {
        instanceV2 = axios.create({
            baseURL: getEngageServerHost(window.location.hostname) + ENGAGE_URLS.API_V2
        });
    }
    return instanceV2;
}

export default {
    getEngageServerHost: getEngageServerHost,

    setToken(newToken) {
        token = newToken;
    },
    updateToken() {
        return this.getToken().then(tokenRes => {
            this.setToken(tokenRes?.data?.data?.token);
        });
    },
    getToken() {
        const headers = {
            'X-Source-Tag': utilities.generateUuid()
        }
        return getInstanceV1().get(`hcp-message/tokens`, { headers: headers });
    },
    formAuthHeaders() {
        return {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'X-Source-Tag': utilities.generateUuid()
        }
    },
    getSigninDetails(signinId) {
        return new Promise((resolve, reject) => {
            getInstanceV1().get(`hcp-message/signin-events/${signinId}`,  { headers: this.formAuthHeaders() })
                .then(resolve)
                .catch(err => {
                    if (err?.response?.status === RESPONSE_STATUS.UNAUTHORIZED) {
                        this.updateToken().then(() => {
                            getInstanceV1().get(`hcp-message/signin-events/${signinId}`,  { headers: this.formAuthHeaders() })
                                .then(resolve)
                                .catch(reject);
                        }).catch(reject);
                    } else {
                        reject(err);
                    }
                });
        });
    },
    submitSignature(signinId, data) {
        return new Promise((resolve, reject) => {
            getInstanceV2().post(`hcp-message/signin-events/${signinId}/signatures`, Object.assign({ "status": SIGNATURE_STATUS.SUBMITTED }, data), { headers: this.formAuthHeaders() })
                .then(resolve)
                .catch(err => {
                    if (err?.response?.status === RESPONSE_STATUS.UNAUTHORIZED) {
                        this.updateToken().then(() => {
                            getInstanceV2().post(`hcp-message/signin-events/${signinId}/signatures`, Object.assign({ "status": SIGNATURE_STATUS.SUBMITTED }, data), { headers: this.formAuthHeaders() })
                                .then(resolve)
                                .catch(reject);
                        }).catch(reject);
                    } else {
                        reject(err);
                    }
                });
        });
    },
    declineSignature(signinId) {
        return new Promise((resolve, reject) => {
            getInstanceV2().post(`hcp-message/signin-events/${signinId}/signatures`, { "status": SIGNATURE_STATUS.DECLINED }, { headers: this.formAuthHeaders() })
                .then(resolve)
                .catch(err => {
                    if (err?.response?.status === RESPONSE_STATUS.UNAUTHORIZED) {
                        this.updateToken().then(() => {
                            getInstanceV2().post(`engage/engage-message/signin-events/${signinId}/signatures`, { "status": SIGNATURE_STATUS.DECLINED }, { headers: this.formAuthHeaders() })
                                .then(resolve)
                                .catch(reject)
                        }).catch(reject);
                    } else {
                        reject(err);
                    }
                });
        });
    },
    logEvent(data) {
        return new Promise((resolve, reject) => {
            getInstanceV1().post(`engage/client-events`,  data, { headers: this.formAuthHeaders() })
                .then(resolve)
                .catch(err => {
                    if (err?.response?.status === RESPONSE_STATUS.UNAUTHORIZED) {
                        this.updateToken().then(() => {
                            getInstanceV1().post(`engage/client-events`,  data, { headers: this.formAuthHeaders() })
                                .then(resolve)
                                .catch(reject);
                        }).catch(reject);
                    } else {
                        reject(err)
                    }
                });
        });
    }
};
